

















































































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
@Component({
  components: { TableActions, CustomTableCol, CustomTableItem }
})
export default class annexList extends Vue {
  @Prop() annex!: any;
  isContractCreating: boolean = false;
  data() {
    return {};
  }

  editContract() {
    this.$router.push({
      name: "contractEdit",
      params: {
        contractId: this.annex.id
      }
    });
  }

  removeContract() {
    if (this.annex) {
      this.isContractCreating = true;
      api.ContractApi._delete(this.annex.id)
        .then(() => {
          this.$router.push({
            name: "contracts"
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isContractCreating = false;
        });
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }
}
